import { Component, input } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';

import { UltraIconComponent } from '../../../ultramarine-ui/ultra-icon/ultra-icon.component';
import { TerminalActionCardModel } from '../../models/terminal-action-card.model';

@Component({
	selector: 'app-terminal-action-card',
	templateUrl: 'terminal-action-card.component.html',
	imports: [UltraIconComponent, TranslocoModule],
	host: {
		class: 'contents',
	},
})
export class TerminalActionCardComponent {
	data = input<TerminalActionCardModel>();
}
